import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { TpvUserAccessRepository } from '@app/domain/ports/tpv/tpv-user-access.repository';
import { TpvUserAccess } from '@app/domain/models/tpv/tpv-user-access.model';
import { TpvUserAccessDto } from '@app/data/dtos/tpv/user-access.dto';
import { mapTpvUserAccess } from '@app/data/mappers/tpv/user-access.mapper';
import { tpvUrl } from '@app/data/tpv/tpv-api.config';
import { TpvEnvelope, unwrapTpv } from '@app/data/tpv/tpv-envelope';

/** `GET /api/v1/tpv/user/access/` (Suite). Auth Bearer vía interceptores estándar. */
@Injectable()
export class TpvUserAccessRemoteDataSource extends TpvUserAccessRepository {
  private readonly http = inject(HttpClient);

  override getAccess(): Observable<TpvUserAccess> {
    return this.http
      .get<TpvEnvelope<TpvUserAccessDto>>(tpvUrl('user/access/'))
      .pipe(map((raw) => mapTpvUserAccess(unwrapTpv<TpvUserAccessDto>(raw))));
  }
}
